<template>
  <AppLink
    :to="url"
    class="
    item flex h-[41px] max-w-[277px] cursor-pointer select-none items-center
    border-l-4 border-l-[--v3-theme-primarydarkestcolor] pl-[46px]
    transition-all duration-150 hover:bg-[--v3-theme-primarydarkestcolor]"
    :class="{
      'bg-[--v3-theme-primarydarkcolor] text-[--v3-theme-primarytextcolor] hover:text-[--v3-theme-primarytextcolor]': !props.active,
      'bg-[--v3-theme-primarydarkercolor] text-[--v3-theme-primarytextcolor]': props.active,
    }"
  >
    <span
      class="item-name whitespace-nowrap transition-[opacity,font-size]"
      :class="{
        'text-[14px] opacity-100': !props.collapsed,
        'text-[0px] opacity-0': props.collapsed,
        'font-bold': props.active,
      }"
    >
      {{ name }}
    </span>
  </AppLink>
</template>

<script lang="ts" setup>
import { computed, inject, onMounted } from 'vue';

import AppLink from '@/common/components/atoms/AppLink';
import { MenuGroupItemsCounterFn } from '@/modules/layout/types/keys';

const props = withDefaults(defineProps<{
  legacyUrl?: string | null | undefined,
  to?: string | null | undefined
  name: string,
  active?: boolean,
  collapsed?: boolean,
}>(), {
  active: false,
  collapsed: false,
  legacyUrl: null,
  to: null,
});

const url = computed(() => props.to || props.legacyUrl);

const IncreaseMenuGroupItemsCounter = inject(MenuGroupItemsCounterFn);

onMounted(() => {
  IncreaseMenuGroupItemsCounter();
});
</script>

<style lang="scss" scoped>
.item-name {
  font-family: Roboto,serif;
}
</style>
